import { useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';

import { translate } from '../functions/translationHelper';

import checkmarkimg from "../img/checkmark-green.svg";

function Voucher(props) {

  let { regionid } = useParams();
  const [infoopen, setinfoopen] = useState(false);

  const [redeemed, setRedeemed] = useState(false);
  const redeemedVoucherKey = `redeemed-vouchers-${regionid || "global"}`;

  function getRedeemedVouchers() {
    try {
      const stored = localStorage.getItem(redeemedVoucherKey);
      const parsed = stored ? JSON.parse(stored) : [];
      return Array.isArray(parsed) ? parsed : [];
    } catch {
      return [];
    }
  }

  useEffect(() => {
    const redeemedVouchers = getRedeemedVouchers().map(String);
    setRedeemed(redeemedVouchers.includes(String(props.id)));
  }, [props.id, redeemedVoucherKey]);

  function redeem(event) {
    event.stopPropagation();

    if (redeemed || props.alltrails < props.badgesneeded) {
      return;
    }

    const confirmed = window.confirm(translate("voucher_redeem_confirm", props?.lang));
    if (!confirmed) {
      return;
    }

    const redeemedVouchers = getRedeemedVouchers();
    if (!redeemedVouchers.map(String).includes(String(props.id))) {
      redeemedVouchers.push(String(props.id));
      localStorage.setItem(redeemedVoucherKey, JSON.stringify(redeemedVouchers));
    }
    setRedeemed(true);
  }

  return (
    <div>
    <div className={`voucher voucher-${props.id}`} onClick={() => setinfoopen(!infoopen)}>
      <div className="vouchertext">
        <p className="voucherprogresstext"><b>{props.alltrails} {translate("progress_of", props?.lang)} {props.badgesneeded}</b> {props.badgesneeded == 1 ? translate("badge_singular", props?.lang) : translate("badge_plural", props?.lang)}</p>
        <div className="voucherprogresscont">
          <div className={`voucherprogressinner ${props.alltrails >= props.badgesneeded && "voucherprogressinnerdone"}`} style={{width: props.alltrails / props.badgesneeded * 100 + "%"}}></div>
        </div>
        <p className="vouchertitle">{props.title}</p>
        <div className='voucherbuttoncontainer'>
        {
          redeemed ?
          <div className='voucherredeemed'><img src={checkmarkimg} style={{width: 16, marginRight: 8}} />{translate("voucher_redeemed", props?.lang)}</div>
        :
        (props.alltrails >= props.badgesneeded ?
          <>
          <div className='voucherbutton voucherbutton-success clickable'>{translate("getnow", props?.lang)}</div>
          <img onClick={redeem} src={checkmarkimg} style={{width: 20, opacity: 0.5, padding: 2}} />
          </>
          :
          <div className='voucherbutton clickable'>{translate("moreinfo", props?.lang)}</div>)
        }
        </div>
      </div>
<div className="voucherimage" style={{backgroundImage: `url(${process.env.REACT_APP_CONTENT_URL}${regionid}/vouchers/voucher-${props.id}.png)`}}>
<div className="voucherdot voucherdot-up"></div>
<div className="voucherdot voucherdot-down"></div>
</div>
        
    </div>
    {infoopen && <div className='vouchermoreinfo'>
      {props.description}
    </div>}
    </div>
  );
}

export default Voucher;
